
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {Link} from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Bis vor wenigen Jahren galt bei vielen erfolgreichen, vor allem männlichen Managern aus Politik und Wirtschaft die Devise: Mache die Nacht zum Tag und lobe dich am besten öffentlich, mit wie wenig Schlaf du auskommst. Die Wissenschaft hat jedoch schon längst erkannt, dass ein länger andauernder Schlafmangel weder kreativ noch leistungsfähig macht, sondern krank und in manchen Fällen sogar depressiv. Es braucht den regelmässigen Rückzug und die Erholung, um bei Kräften zu bleiben. `}<br /></p>
    <M mdxType="M">Eine der Ersten, die zu mehr Schlaf aufforderte, war die ehemalige Gründerin und Chefredaktorin der «Huffington Post», Arianna Huffington.</M> Nach einem Zusammenbruch infolge Arbeitsüberlastung und dem damit einhergehenden Schlafmangel schrieb sie den Bestseller «Die Schlafrevolution», der 2016 auf Deutsch erschien. Darin forderte Huffington ein gesellschaftliches Umdenken. Heute sprechen sich auch viele weitere erfolgreiche Unternehmer wie Microsoft-Gründer Bill Gates (7 Stunden) oder Swiss-Life-Chef Patrick Frost (8 Stunden) für die Notwendigkeit eines gesunden Schlafes aus. Auch der Amazon-Gründer Jeff Bezos benötigt nach eigenen Angaben acht Stunden Schlaf, um als CEO und als Person zu funktionieren und gute Entscheide treffen zu können.<br /><br />
Allgemein zeichnet sich ein Wandel ab: Bereits im Jahr 2014 zeigte das Gottlieb-Duttweiler-Institut in der Studie <Link href='https://www.gdi.ch/de/publikationen/studien-buecher/die-zukunft-des-schlafens' mdxType="Link">«Die Zukunft des Schlafens»</Link> auf, dass der Schlaf in der Welt von morgen einen viel grösseren Stellenwert geniessen und sich vermehrt vom Grundbedürfnis zum Lifestyle-Thema entwickeln dürfte.
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;